import api from "./api";
import { tokenStorage } from "../utils/tokenStorage";
import { buildCredentialToken } from "../utils/encryption";

const AuthService = {
 
async login(username, password) {
  const credentialToken = buildCredentialToken(username, password);

  const { data } = await api.post(
    "/Login/Login",
    {
      UserName: username,
      Password: password,
    },
    {
      headers: {
        "X-My-Secret-Token": credentialToken,
      },
    }
  );
localStorage.setItem("username", username);
  localStorage.setItem("password", password);

  return { ...data, credentialToken };
}
,
 
  async getProfile() {
    const token = tokenStorage.get();
    if (!token) {
      throw new Error("You're not logged in. Please sign in again.");
    }
const username =localStorage.setItem("username", username);
    const { data } = await api.post(`/QrRetrieve/RetrieveDataById?id=${username}`, undefined, {
      headers: { "X-My-Secret-Token": token },
    });
    const profile = JSON.parse(data.responceMessage);

    return {
      firstName: profile.First_Name,
      lastName: profile.Last_Name,
      userName: profile.User_Name,
    };
  },
};

export default AuthService;
